import moment from 'moment';

import { FilterTypes } from '../types';

export const parseQueryFilters = (filters?: FilterTypes) => {
  let resultFiltersQueryString = '';
  if (filters) {
    Object.entries(filters).map(([key, value]) => {
      if (key === 'date' && typeof value === 'object' && value.from && value.to) {
        resultFiltersQueryString += `&filter[date][from]=${value.from}&filter[date][to]=${value.to}`;
      } else if (key === 'type' && value ==='Expense Reimbursement') {
        resultFiltersQueryString += `&filter[${key}]=Advance`;
      } else if (key === 'type' && value === 'Service Provider') {
        resultFiltersQueryString += `&filter[${key}]=SERVICE_PROVIDER`;
      } else if (key === 'onboardingStatus') {
        if (value !== 'All Statuses' && value !== '') {
          resultFiltersQueryString += `&filter[${key}]=${value}`;
        }
      }else if (key === 'processingStatus') {
        if (value !== 'All Statuses' && value !== '') {
          resultFiltersQueryString += `&filter[${key}]=${value}`;
        }
      } else if (key === 'settlementType') {
        if (value !== 'All Types' && value !== '') {
          resultFiltersQueryString += `&filter[${key}]=${value}`;
        }
      } else if (key === 'view' || key === 'settlementId') {
        // Case ledger settlement filter is sent as top-level params, not filter[]
        if (value !== '') {
          resultFiltersQueryString += `&${key}=${encodeURIComponent(String(value))}`;
        }
      }
       else if (value !== '') {
        if (Array.isArray(value) && key === 'statuses') {
          resultFiltersQueryString += `&filter[${key}][]=${value}`;
        } else {
          resultFiltersQueryString += `&filter[${key}]=${value}`;
        }
      }
    });
  }

  return resultFiltersQueryString;
};

export const parseClientBankingFilters = (filters: FilterTypes) => {
  let resultFiltersQueryString = '';

  if (filters) {
    Object.entries(filters).map(([key, value]) => {
      if (value !== '' && moment(value).isValid()) {
        resultFiltersQueryString += `&filter[lastUpdatedOn][${key}]=${value}`;
      } else if (value !== '') {
        resultFiltersQueryString += `&filter[${key}]=${value}`;
      }
    });
  }

  return resultFiltersQueryString;
};

export const parseBankingTransactionFilters = (filters: FilterTypes) => {
  let resultFiltersQueryString = '';

  if (filters) {
    const accountTypeMap: Record<string, string> = {
      'Revenue Recognition': 'REV',
      'Expense Reimbursement': 'EXP',
      'Case Account': 'CASE',
    };
    Object.entries(filters).map(([key, value]) => {
      if (key === 'accountType' && value !== 'All Accounts' && value !== '') {
        const mappedValue = accountTypeMap[value as string] || value;
        resultFiltersQueryString += `&filter[${key}]=${mappedValue}`;
      } else if (key === 'transactionType' && value !== 'All Types' && value !== '') {
        resultFiltersQueryString += `&filter[${key}]=${value}`;
      } else if ((key === 'from' || key === 'to') && value !== '' && moment(value).isValid()) {
        resultFiltersQueryString += `&filter[lastUpdatedOn][${key}]=${value}`;
      }
    });
  }

  return resultFiltersQueryString;
};

export const parseVendorQueryFilters = (filters?: FilterTypes) => {
  let resultFiltersQueryString = '';
  if (filters) {
    Object.entries(filters).map(([key, value]) => {
      if (key === 'defaultPaymentMethod' && value !== 'All Methods' && value !== '') {
        resultFiltersQueryString += `&filter[${key}]=${value}`;
      } else if (key === 'vendorType' && value !== 'All Vendor Types' && value !== '') {
        resultFiltersQueryString += `&filter[${key}]=${value}`;
      } else if (key === 'vendorStatus' && value !== 'All Statuses' && value !== '') {
        resultFiltersQueryString += `&filter[${key}]=${value}`;
      } else if (key === 'date' && typeof value === 'object' && value.from && value.to) {
        resultFiltersQueryString += `&filter[date][from]=${value.from}&filter[date][to]=${value.to}`;
      }

    });
  }

  return resultFiltersQueryString;
};
